function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgSettings = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M18.457 4.283l-1.399 4.014a5.9 5.9 0 01.537.98l4.011.74-.074 3.557-4.046.913a6.954 6.954 0 01-.578 1.001l1.233 3.96-3.043 1.843-2.647-3.104c-.37.043-.744.052-1.117.025l-2.776 3.219-2.969-1.714 1.399-4.014a5.94 5.94 0 01-.537-.98l-4.011-.74.074-3.557 4.046-.913a6.954 6.954 0 01.578-1.001l-1.233-3.96 3.043-1.843 2.646 3.104a5.957 5.957 0 011.117-.025l2.776-3.219 2.969 1.714zm-5.084 5.379c-1.23-.71-2.831-.239-3.577 1.053s-.353 2.914.877 3.624 2.831.239 3.577-1.053.353-2.914-.877-3.624z"
  }));
});
export default SvgSettings;